import { User } from "./user.types";

export type UserActionTypes =
  | FetchUserLoadingAction
  | FetchUserSuccessAction
  | FetchUserErrorAction;

export const FETCH_USER_LOADING = "user/FETCH_USER_LOADING";
export const FETCH_USER_SUCCESS = "user/FETCH_USER_SUCCESS";
export const FETCH_USER_ERROR = "user/FETCH_USER_ERROR";

export interface FetchUserLoadingAction {
  type: typeof FETCH_USER_LOADING;
}
export interface FetchUserSuccessAction {
  type: typeof FETCH_USER_SUCCESS;
  payload: User;
}
export interface FetchUserErrorAction {
  type: typeof FETCH_USER_ERROR;
  payload: String;
}
export const fetchUserLoadingAction = (): FetchUserLoadingAction => ({
  type: FETCH_USER_LOADING,
});
export const fetchUserSuccessAction = (user: User): FetchUserSuccessAction => ({
  type: FETCH_USER_SUCCESS,
  payload: user,
});
export const fetchUserErrorAction = (error: string): FetchUserErrorAction => ({
  type: FETCH_USER_ERROR,
  payload: error,
});
